export const PROTOCOLE_PUNAISES = {
    "intro": "La collaboration avec notre entreprise est cruciale pour venir à bout de l'infestation. La préparation fait partie intégrante du traitement et relève de votre responsabilité. Les consignes d'après-traitement diffèrent selon la méthode utilisée : vapeur sèche 180°C ou traitement chimique.",
    "avant": [
        {
            "num": "01",
            "title": "Préparation de l'espace",
            "items": [
                "Dégagez la pièce de tout désordre superflu et assurez-vous que le sol est libre d'objets.",
                "Démontez les plinthes en bois des chambres et du salon. Éloignez également les meubles des murs.",
                "Nettoyez les sols, bureaux, tiroirs et garde-robes avant de procéder au traitement."
            ]
        },
        {
            "num": "02",
            "title": "Électricité et éclairage",
            "items": [
                "Démontez les lampadaires et autres sources de lumière.",
                "Retirez les plaques des interrupteurs et prises électriques."
            ]
        },
        {
            "num": "03",
            "title": "Décoration murale",
            "items": [
                "Décrochez tout élément attaché aux murs : photos, posters ou tableaux."
            ]
        },
        {
            "num": "04",
            "title": "Précautions pour les textiles",
            "items": [
                "Assurez-vous que les tapis ne sont pas ancrés au sol.",
                "Videz garde-robes, tiroirs et bureaux. Emballez literie et vêtements dans des sacs plastiques fermés hermétiquement, puis retirez-les des pièces. Vérifiez la bonne fermeture des sacs avant tout déplacement.",
                "Lavez la literie et les vêtements à 60°C minimum, ou passez-les au sèche-linge à haute température pendant 30 minutes.",
                "Après nettoyage, placez-les dans des sacs plastiques neufs et refermez-les.",
                "Objets non lavables : congélateur à -20°C minimum pendant au moins 72 heures, emballés dans un sac plastique (60 litres max).",
                "Tapis de qualité, meubles rembourrés et tissus délicats : nettoyage professionnel à la vapeur ou à sec."
            ]
        },
        {
            "num": "05",
            "title": "Lutte contre les nuisibles",
            "items": [
                "Aspirez avec un embout fin pour éliminer punaises et œufs : matelas, cadre de lit, plinthes et boiseries proches du lit. Renouvelez dans toutes les pièces.",
                "Retirez le sac de l'aspirateur après chaque utilisation. Privilégiez les aspirateurs à sac et aspirez quotidiennement après l'application d'insecticide.",
                "Matelas, sommiers et meubles troués ou fissurés : jetez-les de manière responsable, dans le respect des normes environnementales et sanitaires. Placez un avertissement sur les articles contaminés en attente de ramassage pour éviter leur récupération.",
                "Nouveaux matelas et sommiers : conservez leur emballage plastique ou utilisez des housses étanches jusqu'à la fin de l'infestation pour prévenir toute ré-infestation."
            ]
        }
    ],
    "apresMethodes": [
        {
            "method": "Vapeur sèche 180°C",
            "badge": "100% naturelle",
            "tone": "green",
            "icon": "Wind",
            "items": [
                "Aucun produit chimique : le traitement agit uniquement par la chaleur sèche à 180°C, qui élimine adultes, larves et œufs en un seul passage.",
                "Aucun délai d'attente : enfants, femmes enceintes, personnes allergiques ou fragiles et animaux peuvent rester dans le logement pendant et après l'intervention.",
                "Après le passage, aérez simplement les pièces quelques minutes pour évacuer la chaleur et l'humidité résiduelles.",
                "Aucun second rendez-vous n'est nécessaire : contrairement aux insecticides, la chaleur détruit aussi les œufs.",
                "Avant de réutiliser votre lit, vérifiez que le matelas est sec, puis couvrez-le d'une housse étanche. Utilisez des draps et taies d'oreillers propres."
            ]
        },
        {
            "method": "Traitement chimique",
            "badge": "Précautions à respecter",
            "tone": "amber",
            "icon": "SprayCan",
            "items": [
                "Après la pulvérisation d'insecticide, quittez votre domicile pendant au moins 6 heures avant d'y retourner.",
                "Délai de 24 heures recommandé avant le retour pour les enfants, les femmes enceintes, ainsi que les personnes souffrant d'allergies ou de pathologies cardiaques, rénales ou respiratoires.",
                "Bien que les insecticides utilisés soient relativement faibles en toxicité, respecter ce délai est crucial pour minimiser les risques, en particulier pour les personnes les plus vulnérables.",
                "Une fois le délai écoulé, aérez bien les pièces, de préférence en ouvrant les fenêtres pendant au moins 3 heures.",
                "Un second passage 15 jours après le premier est indispensable : les insecticides ne détruisent pas les œufs.",
                "Pour des résultats optimaux, évitez de laver les zones traitées pendant une période allant de 30 à 90 jours.",
                "Une semaine après le second passage, vous pourrez ranger vos vêtements et lingeries dans vos meubles et placards habituels."
            ]
        }
    ],
    "attention": [
        {
            "title": "Livres et papier",
            "text": "en raison des propriétés isolantes du papier, il est difficile de garantir l'éradication complète des punaises potentiellement présentes dans les livres. Placez les livres en petites quantités dans des sacs n'excédant pas 35 litres. Des interventions supplémentaires, voire la destruction de certains ouvrages, pourraient être nécessaires."
        },
        {
            "title": "Second passage (chimique uniquement)",
            "text": "les insecticides ne sont pas efficaces sur les œufs de punaises : un second passage, 15 jours après le premier, est essentiel. La vapeur sèche 180°C élimine quant à elle adultes, larves et œufs en un seul passage. En cas d'infestation sévère, des mesures additionnelles pourraient s'avérer nécessaires."
        }
    ]
};

export const PROTOCOLE_CAFARDS = {
    "intro": "La réussite d'un traitement anti-cafards repose pour moitié sur la préparation de votre logement. Suivez ce protocole avant et après notre intervention pour une éradication complète et durable.",
    "avant": [
        {
            "num": "01",
            "title": "Cuisine & zones de vie",
            "items": [
                "Nettoyez soigneusement la cuisine : plans de travail, sols, tables et zones de repas.",
                "Dégraissez les zones de cuisson et nettoyez derrière et sous les électroménagers (réfrigérateur, four, lave-vaisselle).",
                "Videz et nettoyez les poubelles ; sortez-les si possible la veille de l'intervention."
            ]
        },
        {
            "num": "02",
            "title": "Rangement & accès",
            "items": [
                "Dégagez sous les éviers, les placards et les tiroirs de la cuisine et de la salle d'eau.",
                "Éloignez si possible les meubles des murs pour permettre l'accès aux plinthes.",
                "Signalez au technicien toutes les zones où vous avez observé des cafards ou des traces (excréments, oothèques, odeur)."
            ]
        },
        {
            "num": "03",
            "title": "Alimentation",
            "items": [
                "Rangez tous les aliments dans des contenants hermétiques ou au réfrigérateur.",
                "Ne laissez ni vaisselle sale, ni restes de nourriture, ni gamelles d'animaux accessibles."
            ]
        },
        {
            "num": "04",
            "title": "Animaux & personnes sensibles",
            "items": [
                "Couvrez ou déplacez les aquariums et coupez leur aération pendant la pulvérisation.",
                "Éloignez les animaux domestiques des zones traitées.",
                "Prévoyez de faire sortir les enfants, les femmes enceintes et les personnes fragiles pendant le traitement."
            ]
        }
    ],
    "apres": [
        "Après une pulvérisation, quittez le logement pendant 6 heures (24 heures pour les enfants, les femmes enceintes et les personnes allergiques ou souffrant de pathologies respiratoires), puis aérez au moins 3 heures.",
        "Ne retirez pas les points de gel insecticide : ils agissent pendant plusieurs semaines contre toute la colonie.",
        "Ne lavez pas les plinthes et les zones pulvérisées pendant 3 à 4 semaines pour préserver la rémanence du produit.",
        "Vous pouvez observer des cafards mourants ou désorientés pendant quelques jours : c'est le signe que le traitement agit.",
        "Maintenez une hygiène stricte : miettes, vaisselle, poubelles, points d'eau et humidité favorisent le retour des cafards.",
        "Un second passage est généralement réalisé 15 jours après le premier pour éliminer les jeunes cafards issus des œufs.",
        "Contactez-nous si vous observez encore une activité 3 semaines après le traitement."
    ],
    "attention": [
        {
            "title": "Le gel est votre allié",
            "text": "les points de gel déposés par le technicien contaminent les cafards qui retournent ensuite au nid et éliminent toute la colonie. Les retirer ou les nettoyer réduit fortement l'efficacité du traitement."
        },
        {
            "title": "L'hygiène fait 50% du traitement",
            "text": "sans accès à la nourriture et à l'eau, la colonie ne peut pas se reconstituer. Une hygiène rigoureuse pendant et après le traitement est indispensable à son succès durable."
        }
    ]
};
